import { useEffect } from 'react';

import { useAuth } from '@/hooks/use-auth';

export function SentryUserSync() {
  const { user } = useAuth();

  useEffect(() => {
    if (!import.meta.env.PROD) return;

    import('@sentry/react')
      .then((Sentry) => {
        if (user) {
          Sentry.setUser({ id: user.id, email: user.email ?? undefined });
        } else {
          Sentry.setUser(null);
        }
      })
      .catch(() => {});
  }, [user]);

  return null;
}
